export default [
  {
    path: '/app/blog-categories',
    name: 'BlogCategories',
    component: () => import('@/views/Admin/Blog_categories/Index.vue'),
    meta: {
      pageTitle: 'Blog Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_BLOG_CATEGORIES_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/blog-categories/add',
    name: 'BlogCategoryAdd',
    component: () => import('@/views/Admin/Blog_categories/Add.vue'),
    meta: {
      pageTitle: 'Blog Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/blog-categories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_BLOG_CATEGORIES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/blog-categories/edit/:id',
    name: 'BlogCategoryEdit',
    component: () => import('@/views/Admin/Blog_categories/Edit.vue'),
    meta: {
      pageTitle: 'Blog Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/blog-categories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_BLOG_CATEGORIES_EDIT',
      action: 'read',
    },
  },
]
